import * as React from 'react';
import ReactDOM from 'react-dom/client';

import 'app/config/i18n';
import { ErrorBoundary } from 'app/providers/error';
import { ThemeProvider } from 'app/providers/theme';

import { NotificationsContainer } from 'shared/ui/Notification';

import App from './app';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <App />
        <NotificationsContainer />
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
